import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export default function WizardFooter({
  onBack,
  backDisabled,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  isBusy,
  secondaryLabel,
  onSecondary,
}: {
  onBack?: () => void;
  backDisabled?: boolean;
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  isBusy?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t pt-4">
      <Button type="button" variant="ghost" onClick={onBack} disabled={backDisabled || !onBack}>
        Back
      </Button>
      <div className="flex flex-wrap items-center gap-2">
        {secondaryLabel && onSecondary && (
          <Button type="button" variant="outline" onClick={onSecondary} disabled={isBusy}>
            {secondaryLabel}
          </Button>
        )}
        <Button type="button" onClick={onPrimary} disabled={primaryDisabled || isBusy}>
          {isBusy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
}
